module.exports = __webpack_public_path__ + "img/alcance.fd9dc3d1.svg";